import { BADGE_TYPES, CAROUSEL_NAMES } from '../../utils/constants';

export const carouselNameToExcludedBadges = {
    [CAROUSEL_NAMES.RECENTLY_BOUGHT]: [BADGE_TYPES.BUY_IT_AGAIN],
};
